import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, LocationAttributeDTO, LocationFullDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../../services/error.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UtilService } from '../../../../services/util.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-three-dimensional-impression',
  templateUrl: './three-dimensional-impression.component.html',
  styleUrls: ['./three-dimensional-impression.component.scss'],
  standalone: false,
})
export class ThreeDimensionalImpressionComponent implements OnInit {
  locationId: number;
  location: LocationFullDTO;
  matterportLink: SafeUrl;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public errorHandler: ErrorService,
    public util: UtilService,
    private sanitizationService: DomSanitizer,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      this.locationId = +params.locationID;
      this.api
        .ss_fm_Location_retrieveById(this.locationId)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (e: LocationFullDTO) => {
            this.location = e;
            this.getMatterportView();
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    });
  }

  getMatterportView() {
    if (!this.location?.attributes) {
      return;
    }
    const matterportView: LocationAttributeDTO = this.location.attributes.find(x => x.name === 'Matterport Url');
    const matterportViewVal = matterportView.value;
    if (matterportViewVal) {
      this.matterportLink = this.sanitizationService.bypassSecurityTrustResourceUrl(matterportViewVal);
    }
  }
}
